import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '../base-page/base-page.component';

@Component({
    selector: 'bhub-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    standalone: false
})
export class HelpComponent extends BasePageComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
